import { render } from "./planningPresta.vue?vue&type=template&id=e34fcf7e"
import script from "./planningPresta.vue?vue&type=script&lang=ts"
export * from "./planningPresta.vue?vue&type=script&lang=ts"
script.render = render

export default script